import component from "./AllResultsTabs";

export default component;
